import React from 'react';
import { styled } from '@compiled/react';
import { Flex, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { BenefitLoomBackground } from '../assets/benefit-loom-background';
import messages from '../messages';
import { LoomVideoPlayer } from './video-player';

export const LoomPreview = () => {
	const { formatMessage } = useIntl();

	return (
		<Container>
			<BenefitLoomBackground altText={formatMessage(messages.loomAdImageAltNoTranslate)} />
			<Flex
				direction="column"
				alignItems="center"
				gap="space.200"
				justifyContent="center"
				xcss={xcss({
					position: 'absolute',
					top: '181px',
					left: '173px',
				})}
			>
				<LoomVideoPlayer
					type="video/mp4"
					src="https://cdn.loom.com/assets/marketing/bubbs/angelina.mp4"
				/>
			</Flex>
		</Container>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const Container = styled.div({
	height: '640px',
	width: '570px',
	position: 'relative',
	lineHeight: '0',
});
